import { createAnimations } from "@tamagui/animations-css";

import { springs, toCssTransition } from "./springs";

export const animations = createAnimations({
  press: toCssTransition(springs.press),
  enter: toCssTransition(springs.enter),
  exit: toCssTransition(springs.exit),
  expand: toCssTransition(springs.expand),
  overlay: toCssTransition(springs.overlay),
  reveal: toCssTransition(springs.reveal),
  fade: toCssTransition(springs.fade),
  expressive: toCssTransition(springs.expressive),
});
